$(document).ready(function() {
  var button_reschedule_form = document.querySelector('#button-reschedule-form')
  if (button_reschedule_form != null) {
    button_reschedule_form.addEventListener('click', function() {
      var date = document.querySelector('#date-date')
      var time = document.querySelector('input[name="service_job[reschedule_time]"]:checked')

      var date_value = date.value.length <= 0
      // var time_value = !(time != null)

      if (date_value) {
        document.querySelector('#error-message-date').classList.remove('d-none')
      } else {
        document.querySelector('#error-message-date').classList.add('d-none')
      }

      // if (time_value) {
      //   document.querySelector('#error-message-time').classList.remove('d-none')
      // } else {
      //   document.querySelector('#error-message-time').classList.add('d-none')
      // }

      // if (!date_value && !time_value) {
      if (!date_value) {
        document.querySelector('form').submit()
      }
    })
  }
})
